function onClickArrowUpScroll() {
  document.querySelector('.arrow-up').addEventListener('click', () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  })
}
